const data = [
  { id: 0, name: "Aguardando processamento" },
  { id: 1, name: "Concluído" },
  { id: 2, name: "Processando" },
  { id: 3, name: "Erro no processamento" },
];

export default [...data];
